<template>
  <action-modal
    :object="currentTarget"
    buttonText="Delete"
    @click="deleteTarget"
    ref="modal"
  >
    Are you sure you want to delete target
    <span
      class="delete-target-modal__delete-target-name" :title="currentTarget.display_name">
       {{ currentTarget.display_name }}?
    </span>
  </action-modal>
</template>

<script>
import {ActionModal} from '@/components/common/modal'
import {DELETE_CURRENT_TARGET} from '@/appLogic/targets/currentTarget/store/actions'

export default {
  components: {
    ActionModal
  },
  computed: {
    currentTarget () {
      return this.$store.state.currentTarget.currentTarget
    },
    showModal () {
      return this.$store.state.currentTarget.showDeleteModal
    }
  },
  methods: {
    open () {
      this.$refs.modal.open()
    },
    close () {
      this.$refs.modal.close()
    },
    deleteTarget () {
      this.$store.dispatch(DELETE_CURRENT_TARGET)
    }
  },
  watch: {
    showModal (value) {
      if (value) {
        this.open()
      }
    }
  }
}
</script>

<style lang='scss'>
.delete-target-modal {
  &__delete-target-name {
    display: block;
    margin-top: 20px;
    color: #232A32;
    font-weight: 700;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// DeleteTargetModal.vue?9639a7a4